module.exports = __webpack_public_path__ + "img/sy_nhfw1@3x.8eff0030.png";